import moment from 'moment'
import format from 'date-fns/format'
import formatISO from 'date-fns/formatISO'
import addMinutes from 'date-fns/addMinutes'

const getDateRangeDisplayFormat = ({ startDate, endDate }) => {
  return `${moment(startDate).format('D MMM YYYY')} ${String.fromCharCode(
    0x2014
  )} ${moment(endDate).format(
    moment(endDate).isSame(moment(), 'day')
      ? '[Today,] D MMM YYYY'
      : 'D MMM YYYY'
  )}`
}

const getCurrentYear = () => new Date().getFullYear()

export const getFormattedDateStringFromUnixTimestamp = (
  timestamp,
  formatStr = 'yyyy-MM-dd'
) => format(new Date(timestamp * 1000), formatStr)

export const getFormattedISODateStringFromUnixTimestamp = timestamp =>
  formatISO(new Date(timestamp * 1000))


export const timezoneAdjustedDate = date => {
  const d = new Date(date)
  return addMinutes(d, d.getTimezoneOffset())
}

// adds a Z (utc) at the end of ISO datetime string that do not specify timezone
export const fixUnqualifiedIsoTimezone = date =>
  /T.*Z$|T.*[\+-][\d:]*$/.test(date) || !date.includes('T') ? date : `${date}Z`

export const WEEK_START = 1

export { getDateRangeDisplayFormat, getCurrentYear }
